export default "/images/vendor/flag-icon-css/flags/4x3/by.svg?ed1fb53394827e144c8a4ba1b06e77ed";